export function normalizeUSAddress(component) {
  const parts = [
    component.addrField?.value?.trim() || "",
    component.cityField?.value?.trim() || "",
    component.stateField?.value?.trim() || "",
    component.zipField?.value?.trim() || ""
  ].filter((part) => part?.length > 0);

  return normalizeAddressString(parts.join(" "));
}

export function normalizeAPIResponse(apiResponse, isUSA) {
  if (!apiResponse) return "";

  if (isUSA) {
    const parts = [
      apiResponse.delivery_line_1 || "",
      apiResponse.components?.city_name || "",
      apiResponse.components?.state_abbreviation || "",
      apiResponse.components?.zipcode || ""
    ].filter((part) => part?.length > 0);

    return normalizeAddressString(parts.join(" "));
  }

  return normalizeAddressString(apiResponse.FormattedAddress || "");
}

export function normalizeAddressString(address) {
  return address?.toLowerCase()?.trim()?.replace(/\s+/g, " ")?.trim();
}

export function addressesMatch(userAddress, apiAddress) {
  if (!userAddress || !apiAddress) return false;
  return userAddress === apiAddress;
}
